(() => {

    const mainCont = document.querySelector('[data-vd-component="footer"]');
    const toggles = mainCont.querySelectorAll(".footer-title");
    const mobilewidth = 1024;

    const allContents = mainCont.querySelectorAll("[data-toggled-content]");

 
    function handleResize() {
        if (window.innerWidth < mobilewidth) {
            allContents.forEach(el => el.classList.add("hidden"));
        } else {
            allContents.forEach(el => el.classList.remove("hidden")); 
        }
    }
    
    handleResize();

    window.addEventListener("resize", handleResize);

    toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
            if (window.innerWidth >= mobilewidth) return;

            const hiddenCont = this.parentElement.querySelector("[data-toggled-content]");
            const isOpen = !hiddenCont.classList.contains("hidden");

            const allIcons = mainCont.querySelectorAll(".icon-arrow-down,.icon-arrow-up");

            allContents.forEach((el) => el.classList.add("hidden"));
            allIcons.forEach((icon) => {
                icon.classList.add("icon-arrow-down");
                icon.classList.remove("icon-arrow-up");
            });
            if (!isOpen) {
                hiddenCont.classList.remove("hidden");
                const icon = this.querySelector(".icon-arrow-down, .icon-arrow-up");
                if (icon) {
                    icon.classList.remove("icon-arrow-down");
                    icon.classList.add("icon-arrow-up");
                }
            }
        });
    });
})();
